module.exports = __webpack_public_path__ + "static/media/url-content.00b6935d.svg";